import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55c81230"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-home map-home-pading" }
const _hoisted_2 = { class: "map-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_map_box = _resolveComponent("map-box")!
  const _component_space_box = _resolveComponent("space-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.type == 1 ? 'span-active' : ''),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkMapType(1)))
      }, "列表", 2),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.type == 2 ? 'span-active' : ''),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkMapType(2)))
      }, "地图", 2)
    ]),
    (_ctx.type === 2)
      ? (_openBlock(), _createBlock(_component_map_box, {
          key: 0,
          mapType: 1,
          spaceData: _ctx.spaceData,
          projectId: _ctx.projectId,
          floorId: _ctx.floorId,
          spaceInfo: _ctx.spaceInfo,
          buildingId: _ctx.buildingId,
          onChangeSpace: _ctx.changeSpace
        }, null, 8, ["spaceData", "projectId", "floorId", "spaceInfo", "buildingId", "onChangeSpace"]))
      : _createCommentVNode("", true),
    (_ctx.type === 1)
      ? (_openBlock(), _createBlock(_component_space_box, {
          key: 1,
          spaceData: _ctx.spaceData,
          spaceInfo: _ctx.spaceInfo,
          onChangeSpace: _ctx.changeSpace
        }, null, 8, ["spaceData", "spaceInfo", "onChangeSpace"]))
      : _createCommentVNode("", true)
  ]))
}